class ProductBadges extends HTMLElement {
  hasPopularAddOns = this.hasAttribute('data-synced-with-product-add-ons') || false;

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}:${this.sectionId}`,
      ({ html }) => {
        this.handleBadgeChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
  }

  /**
   * Handle badge change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handleBadgeChange(html) {
    const productBadges = html.querySelector('product-badges');
    this.innerHTML = productBadges?.innerHTML || '';
  }
}

customElements.define('product-badges', ProductBadges);
